import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, BellRing, Users, ShieldCheck, ArrowRight } from 'lucide-react';
import { Section } from './ui/Section';
const WHATSAPP_LINK = 'https://chat.whatsapp.com/K5YhbbcNgvLGErRbE7B3l7';
const benefits = [{
  icon: BellRing,
  title: 'First access to listings',
  description: 'Newly verified hostels are dropped in the group before they go public.'
}, {
  icon: Users,
  title: 'Find roommates faster',
  description: 'Meet students from your campus and shortlist people you actually vibe with.'
}, {
  icon: ShieldCheck,
  title: 'Fraud alerts',
  description: 'Real-time warnings about scam agents and fake listings around your school.'
}];
export function WhatsAppCommunity() {
  return <Section className="bg-brand-dark" data-id="element-373" data-mp="1nlgccqwhzh45">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-374" data-mp="1nom1g654mizv">
        {/* Left: Pitch */}
        <div data-id="element-375" data-mp="1rlry670ljnh7">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.4
        }} transition={{
          duration: 0.5
        }} data-id="element-376" data-mp="3roqkzd9rmiy1">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#25D366]/15 text-[#25D366] text-sm font-medium mb-6" data-id="element-377" data-mp="ks7qax72mro">
              <MessageCircle className="w-4 h-4" data-id="element-378" data-mp="9jvnp612em1y" />
              <span data-id="element-379" data-mp="9h9k1hhaoqp0">WhatsApp Community</span>
            </div>

            <h2 className="text-3xl md:text-5xl font-bold text-white tracking-tight mb-5" data-id="element-380" data-mp="o78gnft7bu2d">
              Join the conversation with{' '}
              <span className="text-brand-primary" data-id="element-381" data-mp="jb9wk4ewoy7r">2,400+ students</span>
            </h2>

            <p className="text-lg text-slate-400 leading-relaxed mb-8 max-w-xl" data-id="element-382" data-mp="x97vq2knoo2o">
              Hostel drops, roommate leads, and scam warnings — all in one group
              chat. It's free, and you can leave any time.
            </p>

            <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-3 rounded-xl bg-[#25D366] px-6 py-4 text-base font-semibold text-white transition-colors hover:bg-[#1ebe5b] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#25D366] focus-visible:ring-offset-2 focus-visible:ring-offset-brand-dark" data-id="element-383" data-mp="3r0oeo0adk2lj">
              <MessageCircle className="w-5 h-5" data-id="element-384" data-mp="dkqexnnr3iak" />
              Join Our WhatsApp Community
              <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-385" data-mp="im62bmdei0w4" />
            </a>

            <p className="mt-4 text-sm text-slate-500" data-id="element-386" data-mp="mleredxhxalc">
              No spam. Community rules are enforced by CampusAparte moderators.
            </p>
          </motion.div>
        </div>

        {/* Right: Benefits */}
        <div className="space-y-4" data-id="element-387" data-mp="2oecq2qdyexe7">
          {benefits.map((benefit, index) => <motion.div key={benefit.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.4
        }} transition={{
          duration: 0.45,
          delay: index * 0.1
        }} className="flex items-start gap-4 rounded-2xl border border-brand-primary/20 bg-brand-dark-secondary/50 p-6" data-id="element-388" data-mp="2gw4sx4y79r8g" data-mpi={index}>
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-primary/20 text-brand-primary" data-id="element-389" data-mp="2qr6l69nrv9f9">
                <benefit.icon className="h-5 w-5" data-id="element-390" data-mp="1fdkwepltr9u9" />
              </div>
              <div data-id="element-391" data-mp="1fevz0m3jabjs">
                <h3 className="text-lg font-bold text-white mb-1" data-id="element-392" data-mp="1fb869p5wxt64">
                  {benefit.title}
                </h3>
                <p className="text-sm text-slate-400 leading-relaxed" data-id="element-393" data-mp="2ybfsz4vklelq">
                  {benefit.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </Section>;
}